<div class="loading-screen">
       <div class="loading-container">
        <div class="company-logo">Yard Hostle</div>
        <div class="spinner"></div>
        <div class="loading-text">Loading Data<span class="dots"></span></div>
        <div class="loading-subtitle">Please wait...</div>
        <div class="progress-bar">
            <div class="progress-fill"></div>
        </div>
    </div>
</div>

